import { memo } from "react";

import { cn } from "@/lib/chillnn/cn";

import { externalLink } from "@/routes/_constants";

import { buttonVariants } from "@/components/ui/button/button";
import OpenInNew from "@/components/ui/icon/open-in-new";
import WarningInfoIcon from "@/components/ui/icon/warning-info";

type Props = {
	hotelID: string;
};

/**
 * 料金一覧はベータ提供。改善要望は Support の共通フィードバックへ送る。
 * 見た目は AirHost 設定ページのベータ案内と同じ warning バナーに揃える。
 */
export const PlanRateMatrixBetaNotice = memo(({ hotelID }: Props) => {
	return (
		<div
			role="alert"
			className="mx-4 mt-4 space-y-3 rounded-lg border border-warning-200 border-l-4 border-l-warning-600 bg-warning-50 p-4 desktop:mx-12 desktop:mt-6"
		>
			<div className="flex items-start gap-3">
				<WarningInfoIcon className="mt-0.5 shrink-0 text-warning-600" size="md" />
				<div className="space-y-1">
					<p className="text-sm tracking-wider font-bold text-warning-600">ベータ版の機能です</p>
					<p className="text-sm text-zinc-600">
						料金一覧は現在ベータ版として提供しています。表示や操作で気になる点があれば、フィードバックをお寄せください。
					</p>
				</div>
			</div>
			<a
				href={externalLink.feedbackSiteUrl(hotelID)}
				target="_blank"
				rel="noopener noreferrer"
				className={cn(buttonVariants({ variant: "outline" }), "h-auto min-h-10 gap-2 bg-white px-4 py-2")}
			>
				フィードバックを送る
				<OpenInNew size="sm" className="shrink-0" />
			</a>
		</div>
	);
});

PlanRateMatrixBetaNotice.displayName = "PlanRateMatrixBetaNotice";
